































































































































import { Input } from './mixins';
import { ValidationProvider } from 'vee-validate';
import { Component, Vue, Prop, Mixins, Emit, Watch } from 'vue-property-decorator';

@Component({
  components: {
    ValidationProvider,
    // @ts-ignore
    VueUploadMultipleImage: () => import('@/components/libraries/VueUploadMultipleImage.vue'),
  },
})
export default class FormImageUpload extends Mixins(Input) {
  @Prop({ default: '' }) readonly value!: any;

  @Prop({ default: 'image/gif,image/jpeg,image/png,image/bmp,image/jpg' }) readonly accept!: any;

  $refs!: Vue['$refs'] & {
    input: HTMLElement;
  };

  @Emit('input')
  update() {
    return this.localValue;
  }

  uploadImageSuccess(formData: FormData, index: number, fileList: Array<{ id?: number; default: number; highlight: number; name: string; path: string }>) {
    // @ts-ignore
    this.localValue = fileList;
    this.update();
  }

  beforeRemove(index: number, done: any, fileList: Array<{ id?: number; default: number; highlight: number; name: string; path: string }>) {
    done();
    // @ts-ignore
    this.localValue = fileList;
    this.update();
  }

  setPrimary(index: number, fileList: Array<{ id?: number; default: number; highlight: number; name: string; path: string }>) {
    this.localValue = fileList;
    this.update();
  }

  editImage(formData: FormData, index: number, fileList: Array<{ default: number; highlight: number; name: string; path: string }>) {
    // TODO:
  }
}
